import type { PushConfig } from '@regia/shared';
import { http } from './api';

function urlBase64ToUint8Array(base64: string): Uint8Array<ArrayBuffer> {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + padding).replace(/-/g, '+').replace(/_/g, '/'));
  const out = new Uint8Array(new ArrayBuffer(raw.length));
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export type PushStatus = 'unsupported' | 'disabled-server' | 'denied' | 'off' | 'on';

export async function getPushStatus(config: PushConfig | undefined): Promise<PushStatus> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window))
    return 'unsupported';
  if (!config?.enabled) return 'disabled-server';
  if (Notification.permission === 'denied') return 'denied';
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  return sub ? 'on' : 'off';
}

/** Chiede il permesso e iscrive questo dispositivo alle notifiche push. */
export async function enablePush(config: PushConfig): Promise<void> {
  if (!config.publicKey) throw new Error('Le notifiche non sono configurate sul server');
  const permission = await Notification.requestPermission();
  if (permission !== 'granted')
    throw new Error(
      'Permesso negato: abilita le notifiche per Regia nelle impostazioni del telefono',
    );
  const reg = await navigator.serviceWorker.ready;
  const sub =
    (await reg.pushManager.getSubscription()) ??
    (await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(config.publicKey),
    }));
  const json = sub.toJSON();
  await http.post('/api/push/subscribe', { endpoint: json.endpoint, keys: json.keys });
}

export async function disablePush(): Promise<void> {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  if (!sub) return;
  await http.post('/api/push/unsubscribe', { endpoint: sub.endpoint });
  await sub.unsubscribe();
}
